module.exports = __webpack_public_path__ + "media/images/icons/icon-tutors-fe4558e2d0a33c4f29e2e39bd7073991.svg";